module.exports = __webpack_public_path__ + "static/img/honor_1.c8d6a2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_1.jpg
// module id = HJgV
// module chunks = 0